import { render, staticRenderFns } from "./signaturelight.vue?vue&type=template&id=3b4021f2&"
import script from "./signaturelight.vue?vue&type=script&lang=js&"
export * from "./signaturelight.vue?vue&type=script&lang=js&"
import style0 from "./signaturelight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports